import { FocusScope } from 'react-aria';
import styles from './Modal.module.scss';

const Backdrop = (props) => {
    return (
        <div
            data-testid={'modal.backdrop'}
            className={styles.Backdrop}
            onClick={props?.onClick}
        >
            {props.children}
        </div>
    );
};

const Modal = ({ onBackdropClick, className, open, ...props }) => {
    const handleBackdropClick = () => {
        if (onBackdropClick) {
            onBackdropClick();
        }
    };

    return (open
        ? <FocusScope contain restoreFocus autoFocus>
            <Backdrop onClick={handleBackdropClick}>
                <div tabIndex={0} className={[className, styles.Modal].join(' ')} { ...props }>
                    {props.children}
                </div>
            </Backdrop>
        </FocusScope>
        : null);
};

export default Modal;
